export default "__VITE_ASSET__CS3_TvJX__"